import {AbstractControl, ValidationErrors} from '@angular/forms';

export class DateValidator {
  static GreaterThanToday(control: AbstractControl): ValidationErrors | null {
    const dateParam = new Date(control.value);
    const currentDate = new Date();
    currentDate.setHours(0);
    currentDate.setMinutes(0);
    currentDate.setSeconds(0);
    currentDate.setMilliseconds(0);

    if (control?.value?.length > 0 && (dateParam.getTime() < currentDate.getTime()))
      return { "LessThanToday": true };

    return null;
  }
}
